<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Master AWB Status  </strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
           <div id="overlay" >
             <div class="loader"></div>
           </div>
              <div id="printableArea" >
            <div class="page-break" v-for="item in masterawbdata" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                         
                          <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'>Country:<b> {{item.country}}</b></span><br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Transport_mode:<b>{{item.transport_mode}}</b></span><br>
                          <!-- <span style ='font-size: 20px;'>Created_date: {{item.created_date}}</span><br>
                          <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br>
                          <span style ='font-size: 20px;'>Dispatch_date: {{item.dispatch_date}}</span><br>
                          -->
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-form-group label="AWB Number" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="masterawb" 
                   v-model="customer.masterawb" v-validate="'required'" 
                   :class="{'input': true, 'is-danger': errors.has('form-1.masterawb') }" placeholder="Enter AWB Number ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.masterawb')" class="help text-danger">{{ errors.first('form-1.masterawb') }}</span>
                   </b-form-group>          
                </b-col> 
               
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button> 
                               
                </b-col>
              </b-row>  
              <b-row> 
                <b-col md="12" >  
                <b-button style="display: none; float: right; " id="printbutton" variant="primary" size="md" value="print a div!" @click="barcodedata('printableArea')">Print AWB Details</b-button>
              </b-col>
            </b-row>
            
            
            </form>
          </div>  
          

            <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :items="masterawbdata" :bordered="bordered" :fields="fields"   :outlined="outlined"  >

             
              <template slot="istatus" slot-scope="row">
                
                <span>{{ (row.item.status==0)?'Created':'Dispatch'}} </span> 
                
                </template>
                
             
               
                

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>           
            </b-table>
              
<!--             
<table style="width:100%">
  
  <tr v-if="shippingidsdata.length >0">
    <th colspan="5">Shipping ID's :</th>
    
  </tr>

  <tr v-for="(item, index) in shippingidsdata">

    <td >{{ item.shippingid}}
    <br>

    </td>
     

</tr>
 
</table> -->
<div >
  <b-row > 
     <b-col md="12" >
   <!--    float: right; -->
  <b-button style="display: none; margin-bottom:2% " id="deletebutton" variant="primary" size="md" value="print a div!" @click="deleteshippingids(shippingidsdata)">Remove Shipping-Id</b-button>
</b-col>
</b-row>
</div>
<div >
     <label  v-if="shippingidsdata.length>0"><b>Shippingid's</b></label>
     <label v-else><b>Shippingid's are not Available</b></label>
   </div>
    <div class="row" >
    
      <div class="col-md-2" style="margin-bottom:2%" v-for="(item, index) in shippingidsdata">

          <input type="checkbox" name="shippingid" @change="deleteshippment($event)"  v-model="checkedShipmentID"  v-bind:value="item.shippingid">
        {{ item.shippingid}}

      </div>
    </div>
    



           

 
              <!--  <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="shippingidsdata" :bordered="bordered" 
               :fields="shippingidsFields" caption-top> -->
           <!--    <template slot="table-caption"><b>Shipping ID's</b></template> -->
           <!--    <template slot="shippingids"> -->
<!--             <table style="width:100%">
               <tr v-if="shippingidsdata.length >0">
    <th colspan="5">Shipping ID's :</th>
    
  </tr>
            <span  v-for="(item, index) in shippingidsdata"> {{ item.shippingid}}
             
        <span><b>,</b></span>
       
             <span v-if="[index]==3"> <br></span>
              
           
            </span>
          </table> -->
              <!-- </template> -->
              
         <!--    </b-table> -->
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueBarcode from 'vue-barcode';
export default {
  data: function () {
    return {
      isBusy: false,
      customer: {},
      outlined:true,
      bordered: true,
      data: [],
      items: [],
    
        shippingidsdata: [],

      fields: [{key: 'master_awb', label: 'Master AWB'}, {key: 'country',label:'Country'},{key: 'transport_mode', label: 'Transfer Mode'},{key: 'istatus', label: 'Status'},{key: 'created_date', label: 'Created Date'},
      {key: 'created_by', label: 'Created By'},{key: 'dispatch_date', label: 'Dispatch Date'}],
      
   

     shippingidsFields:[{key:'shippingids' , label:'Shipping ID' }],
      checkedShipmentID:[],
      masterawbdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,

    }
  },
   components: {
    'barcode': VueBarcode
  },
  created: function () {},
  methods: {
    validateForm(scope) {
      // alert("i m in validate");
document.getElementById("overlay").style.display = "block";
   
                if( this.customer.masterawb=="" || this.customer.masterawb==undefined || this.customer.masterawb==null)  
                {

                  alert("Please insert AWB Number");

                  return false;

                }
                else
                {


         
          const obj = {
             master_awb: this.customer.masterawb
            // master_awb:"UAE676696"
          }
          console.log(obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                 document.getElementById("overlay").style.display = "none";
                this.masterawbdata = result.body.returnvalue
                  this.shippingidsdata = result.body.shipment
                 document.getElementById("printbutton").style.display ="block";
               
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
              else if (result.body.returnmsg =="Unsuccessful") {

                alert(result.body.returnvalue);
                 document.getElementById("overlay").style.display = "none";
              }

               else {
                //alert('Result not found')
                this.masterawbdata = []
                this.shippingidsdata = []
                

              
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
      }
    },

    deleteshippingids(data){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var created_by=userInfo.userfirstname+' '+userInfo.userlastname
      // console.log(data);
      if (confirm('Are you sure to Remove shippment ?')) {

            var shippingidobj = { shippingid :this.checkedShipmentID ,
                                master_awb: this.customer.masterawb ,
                                created_by:created_by 
         

            };
            document.getElementById("overlay").style.display = "block";


            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/removeshipmentsfrommasterawb`,shippingidobj)
            .then(result => {

            var result = result.body.returnmsg;
              if(result=="Successful")

              alert('Shippment Removed Successfully.');
              document.getElementById("deletebutton").style.display ="none";
             const obj = {
             master_awb: this.customer.masterawb
            // master_awb:"UAE676696"
          }
          console.log(obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`,obj)
            .then((result) => {
           
           console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                 document.getElementById("overlay").style.display = "none";

                this.masterawbdata = result.body.returnvalue
                  this.shippingidsdata = result.body.shipment
                
               
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } else {
                //alert('Result not found')
                this.masterawbdata = []
                this.shippingidsdata = []
                

              
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

            })
            .catch(ex => {
              console.log('error-----', ex)
            });

        
  
  
} else {
 
  alert('Shippment Can Not be Delete .');
}
       
    },


        deleteshippment(e){
 var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      console.log(this.checkedShipmentID);
        if (this.checkedShipmentID.length >0)

        {
          // alert(this.checkedShipmentID.length)

            document.getElementById("deletebutton").style.display ="block";

           


        }
        else{
         document.getElementById("deletebutton").style.display ="none";
        }

    },

       barcodedata(printableArea){


      //document.getElementById("printableArea").style.display = "none";

     var printContents = document.getElementById("printableArea").innerHTML;


     // var originalContents = document.body.innerHTML;
     // document.body.innerHTML = printContents;
     // window.print();
     // document.body.innerHTML = originalContents;


    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
      // localStorage.removeItem("reloaded");
     // location.reloaded();
       //self.close();


    },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
       document.getElementById("printbutton").style.display ="none";
          this.masterawbdata = []
          this.shippingidsdata = []
           document.getElementById("deletebutton").style.display ="none";
      
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }

  .shipping table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: left;    
}
.loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
